import {
  Exceptiondt2hlxn7j7vw as Exception,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  commonAsUtf8ToByteArray20rkxdpc9aw5b as commonAsUtf8ToByteArray,
  commonToUtf8Stringyih6e1qg1yoo as commonToUtf8String,
} from './internal/-Utf8.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IOExceptionClass;
function IOException() {
  if (IOExceptionClass === VOID) {
    class $ extends Exception() {
      static f3z(message, cause) {
        var $this = this.vd(message, cause);
        captureStack($this, $this.e3z_1);
        return $this;
      }
      static g3z(message) {
        return this.f3z(message, null);
      }
      static h3z() {
        return this.f3z(null, null);
      }
    }
    initMetadataForClass($, 'IOException', $.h3z);
    IOExceptionClass = $;
  }
  return IOExceptionClass;
}
function asUtf8ToByteArray(_this__u8e3s4) {
  return commonAsUtf8ToByteArray(_this__u8e3s4);
}
var ArrayIndexOutOfBoundsExceptionClass;
function ArrayIndexOutOfBoundsException() {
  if (ArrayIndexOutOfBoundsExceptionClass === VOID) {
    class $ extends IndexOutOfBoundsException() {
      static n3w(message) {
        var $this = this.i3(message);
        captureStack($this, $this.m3w_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ArrayIndexOutOfBoundsException');
    ArrayIndexOutOfBoundsExceptionClass = $;
  }
  return ArrayIndexOutOfBoundsExceptionClass;
}
var EOFExceptionClass;
function EOFException() {
  if (EOFExceptionClass === VOID) {
    class $ extends IOException() {
      static x3x(message) {
        var $this = this.g3z(message);
        captureStack($this, $this.w3x_1);
        return $this;
      }
      static c3y() {
        return this.x3x(null);
      }
    }
    initMetadataForClass($, 'EOFException', $.c3y);
    EOFExceptionClass = $;
  }
  return EOFExceptionClass;
}
function toUtf8String(_this__u8e3s4) {
  return commonToUtf8String(_this__u8e3s4);
}
//region block: exports
export {
  ArrayIndexOutOfBoundsException as ArrayIndexOutOfBoundsException3rm3ooo7dx3e8,
  EOFException as EOFException34hypof9gkxss,
  IOException as IOException3fje1ukjwthwb,
  asUtf8ToByteArray as asUtf8ToByteArray29u89fcaeh9ki,
  toUtf8String as toUtf8Stringtpd5urkuirog,
};
//endregion

//# sourceMappingURL=NonJvmPlatform.mjs.map
